<div class="btn-group" dropdown>
  <button id="button-basic" dropdownToggle type="button" class="dropdown-toggle border-0 bg-none text-primary" aria-controls="dropdown-basic" aria-label="Profil und Logout">
    <i class="bi bi-person-fill"></i>
  </button>
  <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="button-basic">
    <li role="menuitem"><a class="dropdown-item" [routerLink]="['/profile']">
      <i class="bi bi-person-fill"></i> {{'label.profile'|translate}}
    </a></li>
    <li class="divider dropdown-divider"></li>
    <li role="menuitem"><a class="dropdown-item" (click)="logout()" tabindex="0" (keydown.enter)="logout()" (keydown.space)="logout()">
      <i class="bi bi-box-arrow-right"></i> {{'label.logout'|translate}}
    </a></li>
  </ul>
</div>
